import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './services/analytics.service';
import { MarketingAttributionService } from './services/marketing-attribution.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private analyticsService: AnalyticsService,
    private marketingAttribution: MarketingAttributionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.analyticsService.init();

    // Captura GCLID/GBRAID/WBRAID na carga inicial e em cada NavigationEnd para
    // pegar visitantes que entram via deep link com query params.
    this.marketingAttribution.captureFromUrl();
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.marketingAttribution.captureFromUrl());
  }
}
